import styled from "styled-components";

export const Chart = styled.div`
  position: relative;
  z-index: 0;
  `;

export const Text = styled.div`
  position: absolute;
  text-align: left;`

export const Value = styled.div`
  font-size: 1.8em;
  margin: 0;
  padding: 0;`

export const DateText = styled.div`
  font-size: 0.9em;`